import React, { useState, useEffect } from "react";
import { getUser, updateUser } from "../api/user";

export default function UserProfile({ token }) {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    getUser(token).then((userData) => {
      setUser(userData);
      setEmail(userData.email);
    });
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await updateUser(token, { email });
      setMessage("Email actualizado correctamente");
    } catch (error) {
      setMessage("Error al actualizar el email");
    }
  };

  if (!user) {
    return <div>Cargando...</div>;
  }

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-2xl font-bold mb-4">Mi Perfil</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="username" className="block text-gray-700 font-bold mb-2">
            Nombre de usuario
          </label>
          <input
            type="text"
            id="username"
            value={user.username}
            disabled
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-gray-200"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="block text-gray-700 font-bold mb-2">
            Email
          </label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <button
          type="submit"
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          Guardar
        </button>
      </form>
      {message && <p className="mt-4 text-green-500">{message}</p>}
    </div>
  );
}
